import Header from "../components/Header/Header";
import RobotForm from "../components/RobotForm/RobotForm";

const FormPage = () => {
  return (
    <>
      <Header />
      <main className="container">
        <RobotForm />
      </main>
    </>
  );
};

export default FormPage;
